<h1 mat-dialog-title class="text-xl font-medium">{{'settlementaccount.header_update_amount' | translate}}</h1>
    <div mat-dialog-content class="font-medium">
      <p> {{'settlementaccount.description_update_account' | translate}}</p>
    </div>

    <div mat-dialog-actions>
      <button class="button-regular" mat-dialog-close [mat-dialog-close]="true" >{{'settlementaccount.button_yes' | translate}}</button>
      <button class="button-outline" type="button" mat-dialog-close [mat-dialog-close]="false" >{{'settlementaccount.button_no' | translate}}</button>
    </div>
